import { render, staticRenderFns } from "./HostelBeds.vue?vue&type=template&id=015fa0a8"
import script from "./HostelBeds.vue?vue&type=script&lang=js"
export * from "./HostelBeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports